var textarea = "textarea__textarea__-mOWC";
var root = "textarea__root__kusdD";
var large = "textarea__large__BJYMW";
var textareaAlt = "textarea__textareaAlt__ZPNzF";
var rootAlt = "textarea__rootAlt__kS0Qk";

export { large, root, rootAlt, textarea, textareaAlt };
//# sourceMappingURL=textarea.module.css.js.map
